var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChargingPile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 5 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5001 14.5833L35.4167 16.6667",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5001 14.5833L35.4167 16.6667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 22.9167H31.2501C33.5513 22.9167 35.4167 24.7821 35.4167 27.0833V33.3333C35.4167 35.0592 36.8159 36.4583 38.5417 36.4583C40.2676 36.4583 41.6668 35.0592 41.6668 33.3333V18.75L35.4167 12.5",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1667 22.9167H31.2501C33.5513 22.9167 35.4167 24.7821 35.4167 27.0833V33.3333C35.4167 35.0592 36.8159 36.4583 38.5417 36.4583C40.2676 36.4583 41.6668 35.0592 41.6668 33.3333V18.75L35.4167 12.5",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 41.6667V12.5C8.33325 10.1988 10.1987 8.33334 12.4999 8.33334H24.9999C27.3011 8.33334 29.1666 10.1988 29.1666 12.5V41.6667",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 41.6667V12.5C8.33325 10.1988 10.1987 8.33334 12.4999 8.33334H24.9999C27.3011 8.33334 29.1666 10.1988 29.1666 12.5V41.6667",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.9583L15.625 29.1667H21.875L18.75 34.375",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 23.9583L15.625 29.1667H21.875L18.75 34.375",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 41.6667H31.25",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 41.6667H31.25",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 16.6667H29.1666",
    stroke: "#7367f0",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33325 16.6667H29.1666",
    stroke: "black",
    strokeOpacity: 0.1,
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargingPile);
export default __webpack_public_path__ + "static/media/charging-pile.297ff2dae8f509c068933c539f918acb.svg";
export { ForwardRef as ReactComponent };